<div class="container">
  <div class="row">
    <div class="content">
      <div class="box-text d-flex">
        <span class="material-icons">
          task_alt
        </span>
      {{data}}
      </div>
      <span class="material-icons" (click)="closeSnackBar()">
        close
      </span>
<!-- <button mat-flat-button color="accent" >Close</button> -->
    </div>
  </div>
</div>